import axios from 'axios';
import * as Cookie from 'tiny-cookie';

export const createProject = (teamId: string, name: string) => {
  return axios.post<{ id: number }>(
    `/api/v3/teamplan/${teamId}/projects`,
    {
      name,
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const archiveProject = (
  teamId: string,
  projectId: number,
  status: 'active' | 'archived',
) => {
  return axios.patch<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/archive`,
    {
      status,
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const setProjectName = (
  teamId: string,
  projectId: number,
  name: string,
) => {
  return axios.patch<{}>(
    `/api/v3/teamplan/${teamId}/projects/${projectId}/set_name`,
    {
      name,
    },
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};
